import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import { useNavigate } from "react-router-dom";

export default function AdminLogin() {
  const navigate = useNavigate();

  const ADMIN_EMAIL = "33threadsclothingstore@gmail.com";

  const [otp, setOtp] = useState("");
  const [generatedOtp, setGeneratedOtp] = useState("");
  const [step, setStep] = useState(1);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const sendOtp = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    // Generate 6-digit OTP
    const newOtp = Math.floor(100000 + Math.random() * 900000).toString();
    setGeneratedOtp(newOtp);

    try {
      await emailjs.send(
        "service_g5jkf9x",        // Service ID
        "template_mat1lui",       // Template ID
        {
          email: ADMIN_EMAIL,
          passcode: newOtp,       // Matches {{passcode}} in template
          time: "15 minutes",     // Matches {{time}} in template
        },
        "5WIQ1w_jvWXQ612co"       // Public Key
      );

      setStep(2);
    } catch (err) {
      console.error("EmailJS Error:", err);
      setError(
        err?.text || err?.message || "Failed to send OTP. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  const verifyOtp = (e) => {
    e.preventDefault();

    if (otp === generatedOtp) {
      localStorage.setItem("adminToken", "authenticated");
      navigate("/admin/dashboard");
    } else {
      setError("Invalid OTP! Try again.");
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 rounded-xl w-80 shadow-lg border border-gray-300">
        <h2 className="text-2xl font-bold text-center mb-6">
          Admin OTP Login
        </h2>

        {error && (
          <p className="text-red-600 text-center mb-3 font-medium text-sm">
            {error}
          </p>
        )}

        {/* STEP 1 — Send OTP */}
        {step === 1 && (
          <form onSubmit={sendOtp}>
            <p className="text-center text-gray-600 mb-4 text-sm">
              OTP will be sent to:
              <br />
              <span className="font-semibold">{ADMIN_EMAIL}</span>
            </p>

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-black text-white py-2 rounded hover:bg-gray-800 disabled:opacity-50"
            >
              {loading ? "Sending..." : "Send OTP"}
            </button>
          </form>
        )}

        {/* STEP 2 — Enter OTP */}
        {step === 2 && (
          <form onSubmit={verifyOtp}>
            <input
              type="number"
              placeholder="Enter OTP"
              className="w-full mb-3 p-2 border rounded"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              required
            />

            <button
              type="submit"
              className="w-full bg-green-600 text-white py-2 rounded hover:bg-green-700"
            >
              Verify OTP
            </button>

            <button
              type="button"
              onClick={() => {
                setStep(1);
                setError("");
                setOtp("");
              }}
              className="w-full mt-3 bg-gray-300 text-black py-2 rounded"
            >
              Resend OTP
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
